/* src/app/container/pubblicazione-detail/pubblicazione-detail.component.scss */
:host {
  height: 100%;
  width: 100%;
}
.detail-content {
  padding: 0rem 0.6rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.div-info-doc {
  padding: 0.13rem 0rem;
  display: flex;
  justify-content: space-between;
}
::ng-deep .p-toggleable-content {
  max-height: 50vh !important;
}
.flex-grow-1 {
  flex-grow: 1;
}
.d-flex {
  display: flex;
}
.general-field:nth-of-type(even) {
  background: #f2f2f2;
}
.general-field {
  display: flex;
  min-height: 1rem;
}
.general-field label,
.general-field div {
  color: #223446;
  padding: 0.2rem 0;
  font-size: 0.8rem;
}
.general-field label {
  min-width: 9.563rem;
  max-width: 9.563rem;
  text-align: right;
  padding-right: 0.625rem;
  justify-content: flex-end;
}
.general-field div {
  display: flex;
  align-items: center;
  width: 100%;
  border-left: 0.06rem solid grey;
  padding-left: 0.6rem;
}
.allegati-li {
  display: flex;
  justify-content: space-between;
  list-style-type: none;
  padding: 0.13rem 0rem;
  font-size: 0.8rem;
}
.allegati-li:not(:last-child) {
  border-bottom: 0.06rem solid #223446;
}
.preview-inner {
  display: flex;
  position: relative;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
}
.preview-inner > iframe {
  height: 100%;
  width: 100%;
  z-index: 99;
}
.allegati-dropdown {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0.5rem 0;
}
.allegati-dropdown > img {
  cursor: pointer;
  width: 2.063rem;
}
.allegati-dropdown > p-select {
  flex-grow: 1;
}
/*# sourceMappingURL=pubblicazione-detail.component.css.map */
